<template>
  <div class="class-list">
    <GlobalInfoBar
      title="换新活动"
      content="创建管理门店换新活动"
    />
    <GlobalChunk icon="search" title="筛选查询">
      <div slot="filter">
        <From />
      </div>
      <Table />
    </GlobalChunk>
  </div>
</template>

<script>
import From from "./Form";
import Table from "./Table";
export default {
  name: "class-list",
  components: {
    From,
    Table
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style>
</style>